import MonthHeader from './MonthHeader.view';

export default MonthHeader;
